export default "__VITE_ASSET__BTxSTa7R__"